<div #scroll class='scroll'>
  <ng-content></ng-content>
  <loader *ngIf='_loading' color='{{ loaderColor }}'></loader>
  <div class='wrapper-message' *ngIf='!hasMore && endMessage'>
    <p>
      {{ endMessage || '' }}
    </p>
  </div>
</div>
